import { render } from "./IosDownloadSubView.vue?vue&type=template&id=69848c3f&scoped=true"
import script from "./IosDownloadSubView.vue?vue&type=script&lang=js"
export * from "./IosDownloadSubView.vue?vue&type=script&lang=js"

import "./IosDownloadSubView.vue?vue&type=style&index=0&id=69848c3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69848c3f"]])

export default __exports__